
  import {Component, Vue} from 'vue-property-decorator';
  import {IApp} from "@/interfaces/app.interface";
  import {ICar} from "@/modules/Car/interfaces/car.interface";
  import {ICarPopupTables} from "@/modules/Car/interfaces/car-popup-tables.interface";
  import {IAppState} from "@/interfaces/app-state.interface";

  @Component({})
  export default class CarTableArchive extends Vue {
    dateFormat = IApp.DateFormats;

    get storeState(): IAppState { return this.$store.state; }
    get activeCar(): ICar.IEntity { return this.storeState.car.activeCar; }
    get tableList() {
      let tables = this.storeState.car.tables;
      if (!tables || (tables && !tables[ICarPopupTables.CarPopupTableArrayName[ICarPopupTables.CarPopupTab.Archive]])) return [];
      return tables[ICarPopupTables.CarPopupTableArrayName[ICarPopupTables.CarPopupTab.Archive]] || [];
    }

    async getData() {
      let params: ICarPopupTables.ICarTableParams = {
        command: ICarPopupTables.Command.GetEventsLog,
        carId: this.activeCar.carId
      };
      let success = await this.$store.dispatch('car/getTable', params);
    }

    async prepareData() {
      if (!this.tableList.length) await this.getData();
    }

  }
